module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Rundholz Portal","short_name":"RuPo","start_url":"/","background_color":"#315C5E","theme_color":"#FFFFFF","display":"standalone","icon":"src/images/icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"610704fc5aef7235a750ca7c638e6732"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
